import { render, staticRenderFns } from "./article-template.vue?vue&type=template&id=76e6bdcb&scoped=true&"
import script from "./article-template.vue?vue&type=script&lang=js&"
export * from "./article-template.vue?vue&type=script&lang=js&"
import style0 from "./article-template.vue?vue&type=style&index=0&id=76e6bdcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e6bdcb",
  null
  
)

export default component.exports